var RosterSelectors = require("lib/selectors/RosterSelectors");

var ToggleMultiselect = require("components/utility/inputs/ToggleMultiselect");

import { connect } from "react-redux";

require("scratch.scss");

@connect(
	(state, props) => ({
		studentLists: RosterSelectors.studentLists({ state })
	}),
	(dispatch, props) => ({
	})
)
class ScratchPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			selected: {}
		}
	}

	render() {
		const toggles = [
			{
				key: "primary",
				text: "Primary",
				icon: "star",
				select: ToggleMultiselect.SELECT_LEFT_CLICK,
				singleton: true
			}, {
				key: "secondary",
				text: "Secondary",
				icon: "star-empty",
				select: ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK,
			}
		]
		
		var topContent = (
			<div>
				Click a class to set it as primary.<br />
				Hold shift & click to set secondary.
			</div>
		)
		
		return (
			<div className="scratchPage container">
				<header className="pageHeader">
					<h1 className="hideOnPrint">Scratch Page</h1>
				</header>

				<hr />
				
				<ToggleMultiselect topContent={ topContent }
					selected={ this.state.selected }
					toggles={ toggles }
					options={ this.props.studentLists.map(x => ({ key: x.id, text: x.name })) }
				 	onChange={ selected => this.setState({ selected }) } />

			</div>
		);
	}

	componentDidMount() {
		if (this.props.studentLists.length) {
			this.setState({
				selected: {
					[this.props.studentLists[0].id]: "primary"
				}
			})
		}
	}
}

ScratchPage.propTypes = PageStrictPropTypes({
	studentLists: PropTypes.array,
});

module.exports = ScratchPage;


// WEBPACK FOOTER //
// ./modules/components/technical/ScratchPage.js